import { render, staticRenderFns } from "./RegisterClient.vue?vue&type=template&id=bb0287a8&scoped=true"
import script from "./RegisterClient.vue?vue&type=script&lang=js"
export * from "./RegisterClient.vue?vue&type=script&lang=js"
import style0 from "./RegisterClient.vue?vue&type=style&index=0&id=bb0287a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0287a8",
  null
  
)

export default component.exports